import { render, staticRenderFns } from "./ShareMapManager.vue?vue&type=template&id=2bb0d3a8&scoped=true"
import script from "./ShareMapManager.vue?vue&type=script&lang=js"
export * from "./ShareMapManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb0d3a8",
  null
  
)

export default component.exports